/**
 * Created by Thomas Mark
 * Date: 2019-10-29
 * 
 * Hilfsdialog zur Anzeige der JSON-Struktur eines Portfolios.
 * Diese Funktion steht nur im ADMIN-Mode zur Verfügung.
 * 
 * Der Dialog wird mit Alt-Click in einer Kachel gestartet.
 * 
 */
import React from 'react';
import ReactJson from 'react-json-view'
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import * as appActions from "../../../store/actions/appActions";
import * as fileActions from "../../../store/actions/fileActions";
import * as portfolioActions from '../../../store/actions/portfolioActions';

class DebugModal extends React.Component {
    constructor(props) {
        super(props);

        this.component = 'DebugModal'
    }

    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================

    render() {
        const { modalDialog } = this.props.app;
        const { currentPortfolio } = this.props.portfolio;

        const onCancel = () => {
            this.props.setModalDialog(null, null)
        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================
        if (modalDialog.dialog !== this.component) return null;

        const dialogTitle = 'Portfolio Debug-View';

        return (
            <div>
                <Dialog fullScreen open={true} onClose={onCancel} maxWidth={'md'} >
                    <DialogTitle>{dialogTitle}</DialogTitle>
                    <DialogContent>
                        <ReactJson src={currentPortfolio}
                            iconStyle="square"
                            indentWidth={4}
                            displayDataTypes={false}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={onCancel} variant="contained" color="primary">OK</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        app: state.app,
        file: state.file,
        portfolio: state.portfolio,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions, fileActions, portfolioActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(DebugModal);